.lead-assignee {
    margin-top: 32px;
}
